export default __webpack_public_path__ + "static/media/Mark-4-HUD-Artificial Horizon.3611deaa.jpg";